import React, { Component } from 'react';
import './App.css';
import ListComp from './ListComp';

// UI framework component imports
import Button from 'muicss/lib/react/button';

export default class EmailScreen extends Component {

  // Properties used by this component:
  // appActions, deviceInfo

  constructor(props) {
    super(props);
    
    this.state = {
      field: '',
      textarea: '',
    };
  }

  componentDidMount() {
    {
      let dataSheet = this.props.appActions.dataSheets['drinks'];
      let serviceOptions = this.props.appActions.serviceOptions_drinks;
      if ( !this.props.appActions.dataSheetLoaded['drinks']) {
        serviceOptions.servicePath = dataSheet.expandSlotTemplateString("anttis-drinks", this.props.appActions.dataSlots);
        this.props.appActions.loadData_firebase1(dataSheet, serviceOptions, true);
        this.props.appActions.dataSheetLoaded['drinks'] = true;
      }
    }
  }

  componentWillUnmount() {
  }

  componentDidUpdate() {
  }

  componentWillReceiveProps(nextProps) {
  }

  textInputChanged_field = (event) => {
    this.setState({field: event.target.value});
    this.props.appActions.updateDataSlot("ds_toEmail", event.target.value);
  }
  
  textAreaChanged_textarea = (event) => {
    this.setState({textarea: event.target.value});
  }
  
  onClick_elButton = (ev) => {
    this.sendData_button_to_email1();
  
  }
  
  
  sendData_button_to_email1 = () => {
    let endCb = () => {}
  
    // This object contains the data collected from the UI
    let dataFromElements = {
      field: this.state.field,
      textarea: this.state.textarea,
    };
    
    /*
    		"BASEURL": "https://apibridge.neonto.com/api/sendemail",
    		"CLIENTKEY": this._data.clientKey,
    		"SCREENIDS": screenIds,
    		"DATAEXPRS": exprs,
    */
    
    
    const data = {
    	to:      (this.props.appActions.dataSlots ? this.props.appActions.dataSlots['ds_toEmail'] : ''),
    	from:    "antti.sihlman@gmail.com",
    	subject: "Test from React App",
    	text:    this.state.textarea,
    };
    
    // check that email address is something vaguely email-like
    if (data.to.length < 3 || data.to.indexOf('@') === -1) {
      endCb(new Error("Invalid email"));
    	
    	let screenId = 'email';
    	if (screenId.length) {
    		this.props.appActions.goToScreen(screenId, { ...this.props, errorText: "Please fill in your email address." });
    	}
    	return;
    }
    
    const url = "https://apibridge.neonto.com/api/sendemail";
    const fetchOpts = {
      method: 'POST',
    	body: JSON.stringify(data),
    	headers: {
    	  'Content-Type': 'application/json',
    		'X-Neonto-Write-Key': 'gz79lbxl99v5e',
    	}
    };
    
    fetch(url, fetchOpts)
      .then((response) => {
        if (response.status >= 400) {
          throw new Error("Server error: "+response.status);
        }
    		endCb(null);
    		
    		let screenId = 'mydrinks';
    		if (screenId.length) {
    			this.props.appActions.goToScreen(screenId, { ...this.props });
    		}
      })
      .catch((exc) => {
        endCb(exc);
    		
    		let screenId = 'email';
    		if (screenId.length) {
    			this.props.appActions.goToScreen(screenId, { ...this.props, errorText: "An error occurred on the server: "+exc });
    		}
      });
  }
  
  
  render() {
    let layoutFlowStyle = {};
    let baseStyle = {};
    if (this.props.transitionId && this.props.transitionId.length > 0 && this.props.atTopOfScreenStack && this.props.transitionForward) {
      baseStyle.animation = '0.25s ease-in-out '+this.props.transitionId;
    }
    if ( !this.props.atTopOfScreenStack) {
      layoutFlowStyle.height = '100vh';
      layoutFlowStyle.overflow = 'hidden';
    }
    
    const dataSheet_drinks = this.props.dataSheets['drinks'];
    const style_elBackground = {
      width: '100%',
      height: '100%',
     };
    const style_elBackground_outer = {
      backgroundColor: '#f6f6f6',
     };
    
    // Source items and any special components used for list/grid element 'list'.
    let items_list = [];
    let listComps_list = {};
    items_list = items_list.concat(this.props.appActions.getDataSheet('drinks').items);
    
    const style_elList = {
      height: 'auto',  // This element is in scroll flow
     };
    
    const style_elField = {
      display: 'block',
      backgroundColor: 'white',
      paddingLeft: '1rem',
      boxSizing: 'border-box', // ensures padding won't expand element's outer size
      pointerEvents: 'auto',
     };
    
    const style_elTextarea = {
      display: 'block',
      backgroundColor: 'white',
      borderColor: 'lightGray',
      paddingLeft: '1rem',
      boxSizing: 'border-box', // ensures padding won't expand element's outer size
      pointerEvents: 'auto',
     };
    const style_elButton = {
      display: 'block',
      color: 'white',
      textAlign: 'center',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    
    return (
      <div className="AppScreen EmailScreen" style={baseStyle}>
        <div className="background">
          <div className="containerMinHeight elBackground" style={style_elBackground_outer}>
            <div className="appBg" style={style_elBackground} />
          </div>
        </div>
        
        <div className="layoutFlow" style={layoutFlowStyle}>
          <div className="hasNestedComps elList">
            <div style={style_elList}>
              {items_list.map((row, index) => {
                let itemComp = (row._componentId)
                    ? listComps_list[row._componentId]
                    : <ListComp dataSheetId={'drinks'} dataSheetRow={row} appActions={this.props.appActions} deviceInfo={this.props.deviceInfo} locStrings={this.props.locStrings} />;
                return (<div key={row.key}>
                    {itemComp}
                  </div>);
              })}
              <div className="marker" ref={(el)=> this._elList_endMarker = el} />
            </div>
          </div>
          
          <div className="elField">
            <input className="baseFont" style={style_elField} type="text" placeholder={this.props.locStrings.email_field_369236} onChange={this.textInputChanged_field} value={this.state.field}  />
          </div>
          
          <div className="elTextarea">
            <textarea className="baseFont" style={style_elTextarea}  placeholder={this.props.locStrings.email_textarea_641750} onChange={this.textAreaChanged_textarea} value={this.state.textarea}  />
          </div>
        </div>
        
        <div className="screenFgContainer">
          <div className="foreground">
            <Button className="actionFont elButton" style={style_elButton}  color="accent" onClick={this.onClick_elButton} >
              {this.props.locStrings.email_button_537592}
            </Button>
          </div>
        </div>
      </div>
    )
  }
  
}
